import { buildModelManager } from "../builder.js";
const DefaultUserFileSelection = {
  __typename: true,
  id: true,
  accessCount: true,
  category: true,
  clinicalFileId: true,
  compressionApplied: true,
  createdAt: true,
  description: { markdown: true, truncatedHTML: true },
  extractedText: { markdown: true, truncatedHTML: true },
  file: { url: true, mimeType: true, fileName: true },
  fileHash: true,
  fileIdentifier: true,
  fileSizeBytes: true,
  fisdapShiftId: true,
  institution: true,
  isPublic: true,
  lastAccessedAt: true,
  linkedModels: true,
  metadata: true,
  mimeType: true,
  originalFilename: true,
  ownerId: true,
  parentFileId: true,
  processingResults: true,
  sharedWith: true,
  shiftProcessingId: true,
  status: true,
  studentId: true,
  submissionSource: true,
  tags: true,
  title: true,
  updatedAt: true,
  uploadDate: true,
  vectorStoreId: true
};
const modelApiIdentifier = "userFile";
const pluralModelApiIdentifier = "userFiles";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultUserFileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultUserFileSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultUserFileSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultUserFileSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultUserFileSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultUserFileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultUserFileSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByFileIdentifier",
    findByField: "fileIdentifier",
    findByVariableName: "fileIdentifier",
    modelApiIdentifier,
    defaultSelection: DefaultUserFileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByFileIdentifier",
    findByField: "fileIdentifier",
    findByVariableName: "fileIdentifier",
    modelApiIdentifier,
    defaultSelection: DefaultUserFileSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByClinicalFileId",
    findByField: "clinicalFileId",
    findByVariableName: "clinicalFileId",
    modelApiIdentifier,
    defaultSelection: DefaultUserFileSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByClinicalFileId",
    findByField: "clinicalFileId",
    findByVariableName: "clinicalFileId",
    modelApiIdentifier,
    defaultSelection: DefaultUserFileSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createUserFile",
    operationReturnType: "CreateUserFile",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { userFile: { required: false, type: "CreateUserFileInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultUserFileSelection
  },
  {
    type: "action",
    operationName: "bulkCreateUserFiles",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateUserFilesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultUserFileSelection
  },
  {
    type: "action",
    operationName: "updateUserFile",
    operationReturnType: "UpdateUserFile",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      userFile: { required: false, type: "UpdateUserFileInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultUserFileSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateUserFiles",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateUserFilesInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultUserFileSelection
  },
  {
    type: "action",
    operationName: "deleteUserFile",
    operationReturnType: "DeleteUserFile",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteUserFiles",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertUserFile",
    operationReturnType: "UpsertUserFile",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      userFile: { required: false, type: "UpsertUserFileInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateUserFileResult": { hasReturnType: false },
      "... on UpdateUserFileResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultUserFileSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertUserFiles",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertUserFilesInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultUserFileSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "userFileGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const UserFileManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultUserFileSelection,
  operations
);
export {
  DefaultUserFileSelection,
  UserFileManager
};
//# sourceMappingURL=UserFile.js.map
